// src/hooks/useResilientWebSocket.js
import { useEffect, useRef, useState } from "react";

export default function useResilientWebSocket(url, token, onMessage) {
  const wsRef = useRef(null);
  const heartbeatRef = useRef(null);
  const reconnectRef = useRef(null);

  const [status, setStatus] = useState("connecting");
  const backoff = useRef(1000);

  function cleanup() {
    clearInterval(heartbeatRef.current);
    clearTimeout(reconnectRef.current);
  }

  function connect() {
    setStatus(wsRef.current ? "reconnecting" : "connecting");

    const ws = new WebSocket(`${url}?token=${token}`);
    wsRef.current = ws;

    ws.onopen = () => {
      setStatus("connected");
      backoff.current = 1000;

      heartbeatRef.current = setInterval(() => {
        if (ws.readyState === WebSocket.OPEN) {
          ws.send(JSON.stringify({ type: "ping" }));
        }
      }, 25000);
    };

    ws.onmessage = (event) => {
      const msg = JSON.parse(event.data);
      if (msg.type === "pong") return;
      onMessage(msg);
    };

    ws.onerror = () => ws.close();

    ws.onclose = () => {
      setStatus("reconnecting");
      cleanup();

      reconnectRef.current = setTimeout(() => {
        backoff.current = Math.min(backoff.current * 2, 30000);
        connect();
      }, backoff.current);
    };
  }

  useEffect(() => {
    if (!token) return;

    connect();

    return () => {
      cleanup();
      wsRef.current?.close();
      setStatus("disconnected");
    };
  }, [token, url]); // <-- ONLY token and url

  return status;
}